var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"direction":"vertical"}},[_c('top-nav',{staticClass:"hide-when-mobile"}),_c('mobile-top',{staticClass:"hide-when-pc"}),_c('el-main',[_vm._t("default")],2),_c('footer-nav',{staticClass:"hide-when-mobile"}),_c('mobile-footer',{staticClass:"hide-when-pc"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }